const prefix = '/community/api/subs';

export function getSubs(axios = window.$nuxt.$axios) {
  return axios.$get(`${prefix}`);
}

export function addSubs(params, axios = window.$nuxt.$axios) {
  return axios.$post(`${prefix}`, params);
}

export function getRecord(axios = window.$nuxt.$axios) {
  return axios.$get(`${prefix}/pop_record`);
}

export function addRecord(params, axios = window.$nuxt.$axios) {
  return axios.$post(`${prefix}/pop_record`, params);
}